import { FileType } from 'app/constants/fileType'

export const getFileType = (type: number): FileType => {
  let fileType = FileType.Unknown
  switch (type) {
    case 1:
      fileType = FileType.Ddd
      break
    case 2:
      fileType = FileType.Gps
      break
    case 3:
      fileType = FileType.Activity
      break
    case 4:
      fileType = FileType.Absences
      break
    case 5:
      fileType = FileType.Tms
      break
    case 6:
      fileType = FileType.Chart
      break
  }

  return fileType
}
